// HQ 라우트 베이스 경로
//   - hq.newattend.com (전용 도메인) → '' (prefix 없음)
//   - newattend.com/hq/* (레거시 호환) → '/hq'
// 모든 HQ 페이지의 navigate/Link 는 이 상수를 사용해야 함 (하드코딩 '/hq/' 금지).
export const HQ_BASE =
  typeof window !== 'undefined' && window.location.hostname === 'hq.newattend.com'
    ? ''
    : '/hq';
